import React from "react"

import Route from "components/Tvendo/Sale/DataMaster/Route/List.js"
import { LayerProvider } from "contexts/layerContext"

export default function () {

  return (
    <LayerProvider>
      <Route />
    </LayerProvider>
  );
}